/**
 * Tidies a watchlist / filter name for display without destroying it.
 *
 * Deliberately NOT title case: these names are full of tickers and acronyms
 * that must keep their casing — title-casing would turn "US Sector Rotation
 * ETF (XLSR)" into "Us Sector Rotation Etf (Xlsr)" and "OPEC & Oil Supply"
 * into "Opec & Oil Supply". Capitalising only the first letter fixes the real
 * complaint (entries saved as "energy stocks") and cannot corrupt anything,
 * since no correct name begins with a deliberately lowercase word.
 *
 * Applied both on save (so stored data improves) and on display (so names
 * already in the library read correctly without a migration).
 */
export function formatListName(name: string): string {
  const clean = name.trim().replace(/\s+/g, " ");
  const first = clean.search(/[a-zA-Z]/);
  if (first === -1) return clean;
  return clean.slice(0, first) + clean[first].toUpperCase() + clean.slice(first + 1);
}
